import React from 'react'
import PromotersList from '../../pages/Partnerships/Promoters/List'
import PromotersUpdate from '../../pages/Partnerships/Promoters/Update'
import PromotersCreate from '../../pages/Partnerships/Promoters/Create'
import PromotersView from '../../pages/Partnerships/Promoters/View'
import PrivateRoute from '../PrivateRoute'
import { CustomSwitch } from '../../components/CustomSwitch'

export const PromotersRouter = (): JSX.Element => (
  <CustomSwitch>
    <PrivateRoute
      path="/partnerships/promoters"
      exact
      component={PromotersList}
    />
    <PrivateRoute
      path="/partnerships/promoters/create"
      component={PromotersCreate}
      exact
    />
    <PrivateRoute
      path="/partnerships/promoters/view/:id"
      component={PromotersView}
      exact
    />
    <PrivateRoute
      path="/partnerships/promoters/update/:id"
      component={PromotersUpdate}
      exact
    />
  </CustomSwitch>
)
